import React, { useState } from 'react'
import { Divider, Space, Tag, Typography, Upload } from 'antd'
import { PlusCircleOutlined, LoadingOutlined, CloudUploadOutlined, EyeFilled, LeftOutlined, RightOutlined } from '@ant-design/icons';
import CustomModal from '../CustomModal/CustomModal';
import CustomInput from '../CustomInput/CustomInput';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UploadButton from '../UploadButton/UploadButton';

const AtachmentItem = () => {
    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {
        console.log('Clicked Save button');
        setOpen(false);
    };
    const handleCancel = () => {
        setOpen(false);
    };

    const remarks = [
        { id: 1, value: 'Remark value' },
        { id: 2, value: 'Remark value' },
        { id: 3, value: 'Remark value' }
    ]
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        nextArrow: <SlideArrow action='right' />,
        prevArrow: <SlideArrow action='left' />
    };

    return (
        <Space split={<Divider style={{ width: '100%', margin: 0 }} />} direction='vertical' size='large' style={{ paddingTop: 15, width: '100%' }}   >
            <Slider style={{ overflow: 'hidden', width: 0, minWidth: '100%' }} {...settings} >

                {remarks.map((e, i) => <SlideItem key={i} value={e.value} />)}

            </Slider>
            <div style={{ textAlign: 'end' }}>
                <PlusCircleOutlined style={{ fontSize: 25, color: 'var(--color-gray)' }} onClick={showModal} />
                <CustomModal title='Add remark' open={open} handleOk={handleOk} handleCancel={handleCancel} >
                    <UploadButton url='' />
                    <br />
                    <CustomInput type='text' name="remark" label='Description' width='100%' />
                </CustomModal>
            </div>
        </Space>)
}

export default AtachmentItem


export const SlideItem = ({ value }) => {
    const [open, setOpen] = useState(false);
    const showModal = () => {
        console.log('showed')
        setOpen(true);
    };
    const handleOk = () => {
        console.log('showed')
        console.log('Clicked Save button from useModel');
        setOpen(false);
    };
    const handleCancel = () => {
        console.log('showed')
        setOpen(false);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%', marginTop: 10, maxHeight: 70 }} >
            <div className='flex_ver'>
                <Typography.Title level={5}>Uploaded by</Typography.Title>
                <Typography.Text>Jovelle</Typography.Text>

            </div>
            <div className='flex_ver' style={{ width: 150 }}>
                <Typography.Title level={5}>File</Typography.Title>
                <Typography.Link ellipsis={true}>Attachment.pdf</Typography.Link>

            </div>
            <div className='flex_ver'>
                <Typography.Title level={5}>Date & time</Typography.Title>
                <Typography.Text>Mar 25, 2022 09:32 PM</Typography.Text>

            </div>


            <EyeFilled style={{ color: '#8D8D8D', fontSize: 20 }} onClick={showModal} />
            <CustomModal action='view' title='View remark' open={open} handleOk={handleOk} handleCancel={handleCancel} >
                <Typography.Text>Mar 25, 2022 09:32 PM</Typography.Text>
                <Tag color='#FCB116' style={{ marginLeft: 10, borderRadius: 8 }} >Unprocessed</Tag>
                <CustomInput disabled type='text' name="remark" label='Remark' width='100%' value={value} />
            </CustomModal>
        </div>
    )


}

const SlideArrow = ({ className, onClick, action }) => {
    return (
        <div
            className={className}
            onClick={onClick}
        >
            {action === 'right' ?

                <RightOutlined style={{ color: 'var(--color-gray)', fontSize: 25 }} />
                :
                <LeftOutlined style={{ color: 'var(--color-gray)', fontSize: 25 }} />

            }
        </div>
    );
}